import clsx from "clsx";
import { pluralNameOfKind } from "../../../services/cpln";
import { Tooltip } from "../../../components/Tooltip";
import { CustomScrollbars } from "../../../components/Scrollbar";
import { Kind } from "../../../schema/types/base";
import { Checkbox } from "antd";

interface IProps {
  kind: Kind;
  items: { value: string; disabled?: boolean; checked: boolean; onChange?: () => void }[];
  toggleAllItems: () => void;
  selectedItemsLength: number;
}

export const ExportWithItemsColumn = ({ kind, items, toggleAllItems, selectedItemsLength }: IProps) => (
  <div className="export-with-items-modal-column">
    <div className="export-with-items-modal-column-title">
      {pluralNameOfKind(kind)} ({selectedItemsLength})
      {items.length > 5 ? (
        <Checkbox
          onChange={() => toggleAllItems()}
          checked={selectedItemsLength === items.length}
          indeterminate={selectedItemsLength > 0 && selectedItemsLength !== items.length}
        >
          All
        </Checkbox>
      ) : null}
    </div>
    <div className={clsx("export-with-items-modal-column-list", { centerItems: items.length < 0 })}>
      {items.length > 0 ? (
        <CustomScrollbars>
          <div style={{ padding: "0.375rem 0.75rem" }}>
            {items.map((item) => (
              <Checkbox key={item.value} disabled={item.disabled} onChange={item.onChange} checked={item.checked}>
                <Tooltip title={item.value} open={item.value.length >= 30}>
                  {item.value}
                </Tooltip>
              </Checkbox>
            ))}
          </div>
        </CustomScrollbars>
      ) : (
        <span className="export-with-items-modal-column-no-items-found">No {pluralNameOfKind(kind)} Yet.</span>
      )}
    </div>
  </div>
);
